import React, { useState, forwardRef, useEffect, useCallback } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import Button from '@mui/joy/Button';

import Box from '@mui/joy/Box';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';



import StepBrands from '../../Components/CarPages/AddNewModel/StepBrands';
import StepTwo from '../../Components/CarPages/AddNewModel/StepTwo';
import StepThree from '../../Components/CarPages/AddNewModel/StepThree';
import StepFour from '../../Components/CarPages/AddNewModel/StepFour';
import StepFive from '../../Components/CarPages/AddNewModel/StepFive';
import StepGearbox from '../../Components/CarPages/AddNewModel/Gearbox';


///////////////////// API
import { createNewModels, getModelDetails, updateModels } from '../../Api/ModelCar';


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



export default function ImitationModel() {
    const { modelImitationModelId } = useParams()

    const navigate = useNavigate();
    const [roleId, setRoleId] = useState([])
    const [adminType, setAdminType] = useState(null)
    const [currentTab, setCurrentTab] = useState(0);
    const [loading, setLoading] = useState(false)

    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');
    const [dataObj, setDataObj] = useState({
        name_ar: '',
        name_en: '',
        brand_id: '',
        manual:0,
        damage_pieces_price: '',
        year_made: '',
        years_price: '',
        motor: null,
        gearbox: null,
        kilo: []
    })

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const getCurrentTabs = (event, newValue) => {
        setCurrentTab(newValue)
    }

    const nextStepTab = () => {
        if (currentTab == 0 && checkvalidationStepOne()) {
            setCurrentTab(currentTab + 1)
        } else if (currentTab == 1 && checkvalidationStepTwo()) {
            setCurrentTab(currentTab + 1)
        } else if (currentTab == 2 && checkvalidationStepThree()) {
            setCurrentTab(currentTab + 1)
        } else if (currentTab == 3 && checkvalidationStepGearbox()) {
            setCurrentTab(currentTab + 1)
        } else if (currentTab == 4 && checkvalidationStepFour()) {
            setCurrentTab(currentTab + 1)
        } else if (currentTab == 5 && checkvalidationStepFive()) {
            subMitNewModels();
            setCurrentTab(0)
        } else {
            setCurrentTab(currentTab)
            setMessageAlertError("برجاء ملئ الحقول الفارغة")
            setOpenAlertError(true)
        }

    }
    const prevStepTab = () => {
        setCurrentTab(currentTab - 1)

    }

    const getDataFromStepOne = (data) => {
        if (data) {
            setDataObj((prev) => {
                return {
                    ...prev,
                    brand_id: data.id
                }
            })
        }
    }

    const getDataManual = (data) => {
        // if (data) {
            setDataObj((prev) => {
                return {
                    ...prev,
                    manual: data ? 1 : 0
                }
            })
        // }
    }

    const getDataFromStepTwoNameAr = (data) => {
        if (data) {
            setDataObj((prev) => {
                return {
                    ...prev,
                    name_ar: data
                }
            })
        }
    }

    const getDataFromStepTwoNameEn = (data) => {
        if (data) {
            setDataObj((prev) => {
                return {
                    ...prev,
                    name_en: data
                }
            })
        }
    }

    const getDataFromStepThreeYearMade = (data) => {
        if (data) {
            setDataObj((prev) => {
                return {
                    ...prev,
                    year_made: data
                }
            })
        }
    }

    //////////////////// Values Years
    const getDataFromStepThreeYearsValues = (data) => {
        if (data) {
            setDataObj((prev) => {
                return {
                    ...prev,
                    years_price: data
                }
            })
        }
    }

    //////////////////// damage_pieces_price
    const getDataFromStepFour = (data) => {
        if (data) {
            setDataObj((prev) => {
                return {
                    ...prev,
                    damage_pieces_price: data
                }
            })
        }
    }
    //////////////////// Values Motor
    const getDataFromStepMotor = (data) => {
        if (data) {
            setDataObj((prev) => {
                return {
                    ...prev,
                    motor: data
                }
            })
        }
    }

    //////////////////// Values Gearbox
    const getDataFromStepGearbox = (data) => {
        if (data) {
            setDataObj((prev) => {
                return {
                    ...prev,
                    gearbox: data
                }
            })
        }
    }

    //////////////////// Values K.M
    const getDataFromStepFiveValues = (data) => {
        if (data) {
            setDataObj((prev) => {
                return {
                    ...prev,
                    kilo:[
                        {fromKM: 0, toKM:10000, price:data[0]?.price},
                        {fromKM: 10001, toKM:20000, price:data[1]?.price},
                        {fromKM: 20001, toKM:40000, price:data[2]?.price},
                        {fromKM: 40001, toKM:60000, price:data[3]?.price},
                        {fromKM: 60001, toKM:80000, price:data[4]?.price},
                        {fromKM: 80001, toKM:100000, price:data[5]?.price},
                        {fromKM: 100001, toKM:130000, price:data[6]?.price},
                        {fromKM: 130001, toKM:160000, price:data[7]?.price},
                        {fromKM: 160001, toKM:200000, price:data[8]?.price},
                        {fromKM: 200001, toKM:250000, price:data[9]?.price},
                        {fromKM: 250000, toKM:0,  price:data[10]?.price}
                    ]
                }
            })
        }
    }

    // console.log(":dataObj  >>>>", dataObj)

    const getOldData = useCallback(async () => {
        // let oldDataObj = null
        const res = await getModelDetails(modelImitationModelId);
        if (res) {
            // oldDataObj = res.find((model) => model.id == modelImitationModelId)
            setDataObj((prev) => {
                return {
                    // name_ar: oldDataObj.name_ar,
                    // name_en: oldDataObj.name_en,
                    brand_id: res.brand_id.id,
                    manual:res.manual,
                    damage_pieces_price: res.damage_pieces_price,
                    year_made: res.year_made,
                    years_price: res.years_price,
                    motor: res.motor,
                    gearbox: res.gearbox,
                    kilo: res.kilos
                }
            })
        }
    }, [])


    const subMitNewModels = async () => {
        setLoading(true)
        try {
            const res = await createNewModels(dataObj);
            if (res) {
                setMessageAlert(" تم نسخ بيانات الموديل بنجاح وانشاء موديل جديد بنجاح")
                setOpenAlert(true)
                setLoading(false)
                if(adminType == 0) {
                    localStorage.setItem('activeTabCarsInSoomha', 'models')
                }else{
                    localStorage.setItem('activeTabCarsInSoomha', null)
                }
                setTimeout(() => {
                    navigate('/cars')
                },3000) 
                setCurrentTab(0)
            }
        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
                setCurrentTab(5)
            }
        }
    }

    const cancelSteps = () => {
        setCurrentTab(0)
        if(adminType == 0) {
            localStorage.setItem('activeTabCarsInSoomha', 'models')
        }else{
            localStorage.setItem('activeTabCarsInSoomha', null)
        }
        navigate('/cars')
    }

    const checkvalidationStepOne = () => {
        if (dataObj.brand_id) {
            return true;
        } else {
            return false
        }
    }
    const checkvalidationStepTwo = () => {
        if (dataObj.name_ar && dataObj.name_en) {
            return true;
        } else {
            return false
        }
    }
    const checkvalidationStepThree = () => {
        if (dataObj.year_made && dataObj.years_price.length == 10) {
            return true;
        } else {
            return false
        }
    }

    const checkvalidationStepGearbox = () => {
        if (dataObj.gearbox && dataObj.motor) {
            return true;
        } else {
            return false
        }
    }

    const checkvalidationStepFour = () => {
        if (dataObj.damage_pieces_price) {
            return true;
        } else {
            return false
        }
    }
    const checkvalidationStepFive = () => {
        if (dataObj.kilo) {
            return true;
        } else {
            return false
        }
    }

    useEffect(() => {
        getOldData();
    }, [getOldData])

    const getRoleAamin = useCallback(async () => {
        let role = await JSON.parse(localStorage.getItem("adminRoleSoomha"));
        let typeAdmin = await JSON.parse(localStorage.getItem("typeAdminSoomha"));
        let roles = role.map((roleIds) => {
            return roleIds.role_id
        })
        let numberArray = roles.map(Number);
        setRoleId(numberArray)
        setAdminType(typeAdmin)
    }, [])


    useEffect(() => {
        getRoleAamin()
    }, [getRoleAamin])

    return (
        <>
            {/* Alert Message */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>
            <Tabs
                variant='plain'
                aria-label="Pricing plan"
                defaultValue={0}
                value={currentTab}
                onChange={getCurrentTabs}
                sx={{
                    width: '100%',
                    borderRadius: 'sm',
                    // boxShadow: 'sm',
                    overflow: 'auto',
                    backgroundColor: '#FBFBFB',
                }}
            >
                <TabList
                    disableUnderline
                    tabFlex={1}
                    size='lg'
                    sx={{
                        width: '90% !important',
                        [`& .${tabClasses.root}`]: {
                            fontSize: 'sm',
                            fontWeight: 'lg',
                            bgcolor: '#FBFBFB',
                            color: '#CBCBCB',

                            [`&[aria-selected="true"]`]: {
                                color: '#282828',
                                bgcolor: '#FBFBFB',
                            },
                            [`&.${tabClasses.focusVisible}`]: {
                                outlineOffset: '-4px',
                                bgcolor: '#FBFBFB',
                            },

                        },
                    }}
                >
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        الماركة
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        الموديل
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        سنة الصنع
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        المحرك و الجيربوكس
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        الصدمات
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        المسافة المقطوعة
                    </Tab>
                </TabList>

                <TabPanel value={0} sx={{ backgroundColor: '#FFF', padding: '60px 25px' }}>
                    <StepBrands getDataFromStepOne={getDataFromStepOne} dataObjBrandId={dataObj.brand_id} getDataManual={getDataManual} dataManual={dataObj.manual}/>
                </TabPanel>
                <TabPanel value={1} sx={{ backgroundColor: '#FFF', padding: '60px 25px' }}>
                    <StepTwo
                        getDataFromStepTwoNameAr={getDataFromStepTwoNameAr}
                        getDataFromStepTwoNameEn={getDataFromStepTwoNameEn}
                        dataObjNameAr={dataObj.name_ar}
                        dataObjNameEn={dataObj.name_en}
                    />
                </TabPanel>
                <TabPanel value={2} sx={{ backgroundColor: '#FFF', padding: '60px 25px' }}>
                    <StepThree
                        getDataFromStepThreeYearMade={getDataFromStepThreeYearMade}
                        getDataFromStepThreeYearsValues={getDataFromStepThreeYearsValues}
                        yearMade={dataObj.year_made}
                        yearsPrice={dataObj.years_price}
                    />
                </TabPanel>
                <TabPanel value={3} sx={{ backgroundColor: '#FFF', padding: '60px 25px' }}>
                    <StepGearbox
                        getDataFromStepMotor={getDataFromStepMotor}
                        getDataFromStepGearbox={getDataFromStepGearbox}
                        gearBoxValue={dataObj.gearbox}
                        motorValue={dataObj.motor}
                    />
                </TabPanel>
                <TabPanel value={4} sx={{ backgroundColor: '#FFF', padding: '60px 25px' }}>
                    <StepFour
                        getDataFromStepFour={getDataFromStepFour}
                        damagePiecesPrice={dataObj.damage_pieces_price}
                    />
                </TabPanel>
                <TabPanel value={5} sx={{ backgroundColor: '#FFF', padding: '60px 25px' }}>
                    <StepFive
                        getDataFromStepFiveValues={getDataFromStepFiveValues}
                        dataObjKilo={dataObj.kilo}
                    />
                </TabPanel>
            </Tabs>


            <Box
                sx={{
                    display: 'flex',
                    // gridTemplateColumns: 'repeat(5, minmax(80px, 1fr))',
                    gap: 1,
                    justifyContent: 'flex-end',
                    backgroundColor: '#FFF',
                    padding: '50px'
                }}
            >
                <Button size="lg" variant='solid' onClick={cancelSteps} color="neutral" sx={{ borderRadius: '30px', width: '20%' }}>
                    الغاء
                </Button>
                {currentTab != 0 ? (
                    <Button size="lg" variant='outlined' onClick={prevStepTab} color="primary" sx={{ borderRadius: '30px', width: '20%' }}>
                        السابق
                    </Button>

                ) : false}
                <Button loading={loading} size="lg" variant='solid' color="primary" onClick={nextStepTab} sx={{ backgroundColor: '#3E64F4', borderRadius: '30px', width: '20%' }}>
                    {currentTab == 5 ? "انشاء" : "التالي"}
                </Button>


            </Box>
        </>
    )
}